import * as Immutable from 'immutable'
import L, { FitBoundsOptions, LatLngLiteral } from 'leaflet'
import { OpenStreetMapProvider } from 'leaflet-geosearch'
import * as React from 'react'
import {
  Action,
  Fun
} from 'widgets-for-react'
import { map_address_to_map_entity } from '../public_site/blocks/custom_blocks/widgets/mapBlock'
import { WordPress } from '../wordpress/wordpress_api'
import {
  CategoriesList, MapEntity,

  MapsState, MapStyling,




  PresentationState, SelectionStatusType,

  SimpleList
} from './maps_types'
import { remove } from 'diacritics'

// setup
export const provider = new OpenStreetMapProvider()

export const locationToString: Fun<WordPress.LocationResponse, string> = l =>
  [
    l.acf.street,
    l.acf.postal_code,
    l.acf.number,
    l.acf.number_addition,
    l.acf.city,
    l.acf.country
  ].join(' ')

export const distanceLimit = 2000 //in meters
export const boundsOptions: FitBoundsOptions = { padding: [0, 0] }

export var hoppinger: LatLngLiteral = { lat: 51.9242, lng: 4.4818 }
export var center_amersfoort: LatLngLiteral = { lat: 52.15659, lng: 5.38892 }

let randomGeo = (center: LatLngLiteral, radius): LatLngLiteral => {
  var y0 = center.lat
  var x0 = center.lng
  var rd = radius / 111300

  var u = Math.random()
  var v = Math.random()

  var w = rd * Math.sqrt(u)
  var t = 2 * Math.PI * v
  var x = w * Math.cos(t)
  var y = w * Math.sin(t)

  return { lat: y + y0, lng: x + x0 }
}

//Generate a number of mappoints
export function generateMapPoints(
  centerpoint: LatLngLiteral,
  distance: number,
  amount: number
): LatLngLiteral[] {
  var mappoints: LatLngLiteral[] = []
  for (var i = 0; i < amount; i++) {
    mappoints.push(randomGeo(centerpoint, distance))
  }
  return mappoints
}

export function generateMapEntity(
  centerpoint: LatLngLiteral,
  distance: number,
  amount: number
): Immutable.List<MapEntity> {
  var mappoints: Immutable.List<LatLngLiteral> = Immutable.List()
  for (var i = 0; i < amount; i++) {
    mappoints = mappoints.push(randomGeo(centerpoint, distance))
  }
  let res: Immutable.List<MapEntity> = Immutable.List<MapEntity>(
    mappoints.map(
      p =>
        ({
          position: p,
          info_when_on_list: (e, presentation_mode: PresentationState) => (
            <MapListItem
              presentationMode={presentation_mode.value.kind}
              {...({
                country: 'The Netherlands',
                offices: [{}, {}]
              } as WordPress.LocationResponse['acf'])}
            />
          ),
          info_when_on_map: e => (
            <div className='map-modal'>
              <h3 className='map-modal__title'>De Hypotheker Rotterdam Blijdorp</h3>

              <div className='map-modal__address'>
                Stadhoudersweg 69-71
                <br />
                3039 EA Rotterdam
                <br />
                010-7143210
              </div>

              <a href='#' className='btn btn--secondary map-modal__button'>
                Bekijk de website
              </a>
              {/* {`x:${p.lng}y:${p.lat}`} */}
            </div>
          ),
          show_info_on_map: 'on_click',
          icon: e => (e.selection_status != 'none' ? example_handDownPoint : example_pointerIcon),
          selection_status: 'none'
        } as MapEntity)
    )
  )
  return res
}

export type PresentationValues = 'show list and map' | 'show map' | 'show list'

export type MapListItemProps = WordPress.LocationResponse['acf'] & {
  presentationMode: PresentationValues
}

export let get_lang_from_url = (path: Action<string>) => {
  let lang: string = ""
  if(window.location.pathname != "/"){
    let path_split = window.location.pathname.split("/")
    if(path_split.length > 1 && path_split[1].length == 2){
      lang = '/' + path_split[1] as string
    }
  }
  return lang + path(lang)
}


export function MapListItem(props: MapListItemProps): JSX.Element {
  const offices = props.offices ? props.offices.length : 0
  return (
    <a className='list__link' href={get_lang_from_url(lang => `/${lang == '' ? 'country' : 'land'}/${remove(props.country)}`)}>
      <h3 className='list__title typo--xs'>{props.country}</h3>
      <span className='list__label typo--4xs'>
        {offices} {`location${offices > 1 ? 's' : ''}`}
      </span>
    </a>
  )
}

export let update_selection_status = function(
  set_state: (_: Action<MapsState>) => void,
  data: CategoriesList | SimpleList,
  e: MapEntity,
  status: SelectionStatusType
) {
  let will_update = false
  let was_prev_e_list_hover_or_click = false
  if (data.kind == 'list_category') {
    data.categories.forEach(c => {
      if (c.title == data.selected_category) {
        c.entities.forEach(l => {
          const e1 = map_address_to_map_entity(l)
          if (are_cord_same(e1.position, e.position) && e1.selection_status != status) {
            was_prev_e_list_hover_or_click =
              e1.selection_status == 'selected_in_list' || e1.selection_status == 'hovered_in_list'
            will_update = true
          }
        })
      }
    })
  } else {
    data.entities.forEach(l => {
      const e1 = map_address_to_map_entity(l)
      if (are_cord_same(e1.position, e.position) && e1.selection_status != status) {
        was_prev_e_list_hover_or_click =
          e1.selection_status == 'selected_in_list' || e1.selection_status == 'hovered_in_list'
        will_update = true
      }
    })
  }

  if (!will_update) return
  set_state(s => {
    let s1 = {
      ...s,
      internal_cluster_key:
        status == 'selected_in_list' ||
        status == 'hovered_in_list' ||
        (status == 'none' && was_prev_e_list_hover_or_click)
          ? s.internal_cluster_key + 1
          : s.internal_cluster_key
    }
    if (s1.data_to_display.kind == 'simple_list') {
      let entities = s1.data_to_display.entities.map(l => {
        const e1 = map_address_to_map_entity(l)
        return are_cord_same(e.position, e1.position)
          ? { ...l, selection_status: status }
          : status == 'selected_in_list' || status == 'selected_on_map'
          ? { ...l, selection_status: 'none' as 'none' }
          : {
              ...l,
              selection_status:
                e1.selection_status == 'selected_in_list' ||
                e1.selection_status == 'selected_on_map'
                  ? e1.selection_status
                  : ('none' as 'none')
            }
      })
      s1.data_to_display.entities = entities.toList()
    } else {
      let selected_cat = s1.data_to_display.selected_category
      let categories1 = s1.data_to_display.categories
        .map(c =>
          c.title == selected_cat
            ? {
                ...c,
                entities: c.entities
                  .map(l => {
                    const e1 = map_address_to_map_entity(l)
                    return are_cord_same(e.position, e1.position)
                      ? { ...l, selection_status: status }
                      : status == 'selected_in_list' || status == 'selected_on_map'
                      ? { ...l, selection_status: 'none' as 'none' }
                      : {
                          ...l,
                          selection_status:
                            e1.selection_status == 'selected_in_list' ||
                            e1.selection_status == 'selected_on_map'
                              ? e1.selection_status
                              : ('none' as 'none')
                        }
                  })
                  .toList()
              }
            : c
        )
        .toList()
      s1.data_to_display = { ...s1.data_to_display, categories: categories1 }
    }
    return s1
  })
}

export let example_icon1 =
  "data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath d='M256 0c-88.366 0-160 71.634-160 160 0 160 160 352 160 352s160-192 160-352c0-88.366-71.635-160-160-160zM256 258c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98zM194 160c0-34.242 27.758-62 62-62s62 27.758 62 62c0 34.242-27.759 62-62 62s-62-27.758-62-62z'%3E%3C/path%3E%3C/svg%3E%0A"
export let example_icon2 =
  "data:image/svg+xml,%3C!-- Generated by IcoMoon.io --%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath d='M480 208v80c0 26.467-21.533 48-48 48-8.552 0-16.588-2.247-23.549-6.184-8.538 13.331-23.48 22.184-40.451 22.184-12.282 0-23.502-4.638-32-12.252-8.498 7.614-19.718 12.252-32 12.252-5.607 0-10.993-0.967-16-2.742v114.742c0 26.467-21.533 48-48 48-26.468 0-48-21.533-48-48v-197.338l-88.009 46.918c-7.269 4.199-15.563 6.42-23.991 6.42-26.468 0-48-21.533-48-48 0-13.184 5.236-25.476 14.744-34.613 0.124-0.119 0.248-0.235 0.375-0.35l119.585-109.037h-22.704c-8.837 0-16-7.163-16-16v-96c0-8.837 7.163-16 16-16h320c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16h-22.111l36.421 72.845c1.112 2.221 1.69 4.671 1.69 7.155zM448 80c0-8.837-7.163-16-16-16s-16 7.163-16 16 7.163 16 16 16 16-7.163 16-16zM448 211.777l-41.889-83.777h-191.912l-145.41 132.584c-3.090 3.033-4.789 7.081-4.789 11.416 0 8.822 7.178 16 16 16 2.729 0 5.306-0.654 7.662-1.947 0.265-0.162 0.535-0.316 0.811-0.463l112-59.708c4.96-2.644 10.942-2.493 15.76 0.4 4.819 2.891 7.767 8.098 7.767 13.718v224c0 8.822 7.178 16 16 16s16-7.178 16-16v-160c0-8.836 7.163-16 16-16s16 7.164 16 16c0 8.822 7.178 16 16 16s16-7.178 16-16c0-8.837 7.163-16 16-16s16 7.163 16 16c0 8.822 7.178 16 16 16s16-7.178 16-16v-16c0-8.837 7.163-16 16-16s16 7.163 16 16c0 8.822 7.178 16 16 16s16-7.178 16-16v-76.223z'%3E%3C/path%3E%3C/svg%3E%0A"
export let example_icon3 =
  "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='yes'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill='%23000000'%3E%3Cpath fillRule='evenodd' d='M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z'/%3E%3C/svg%3E%0A"

export const mk_icon = icon =>
  new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconAnchor: [5, 55],
    popupAnchor: [10, -44],
    iconSize: [25, 55],
    shadowUrl: '',
    shadowSize: [68, 95],
    shadowAnchor: [20, 92]
  })

export let example_pointerIcon = mk_icon(example_icon1)
export let example_handDownPoint = mk_icon(example_icon2)
export let example_plus = mk_icon(example_icon3)

export function getDistance(origin: LatLngLiteral, destination: LatLngLiteral) {
  // return distance in meters
  var lon1 = toRadian(origin.lng),
    lat1 = toRadian(origin.lat),
    lon2 = toRadian(destination.lng),
    lat2 = toRadian(destination.lat)

  var deltaLat = lat2 - lat1
  var deltaLon = lon2 - lon1

  var a =
    Math.pow(Math.sin(deltaLat / 2), 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon / 2), 2)
  var c = 2 * Math.asin(Math.sqrt(a))
  var EARTH_RADIUS = 6371
  return c * EARTH_RADIUS * 1000
}
function toRadian(degree) {
  return (degree * Math.PI) / 180
}

export let mocked_up_categories = Immutable.List<{
  title: string
  entities: Immutable.List<MapEntity>
}>([
  { title: 'Cat-A', entities: generateMapEntity(center_amersfoort, 2000, 50) },
  { title: 'Cat-B', entities: generateMapEntity(center_amersfoort, 3000, 50) },
  { title: 'Cat-C', entities: generateMapEntity(center_amersfoort, 4000, 50) }
])

export let apply_layer = (provider_name, map) => {
  map.eachLayer(l => {
    if (l['_url'] != undefined) map.removeLayer(l)
  })
  L.tileLayer.provider(provider_name).addTo(map)
}
export let mocked_up_tile_provides = Immutable.List<{ name: string; apply: (map: L.Map) => void }>([
  {
    name: 'OpenStreetMap.Mapnik',
    apply: (map: L.Map) => {
      apply_layer('OpenStreetMap.Mapnik', map)
    }
  },
  {
    name: 'OpenTopoMap',
    apply: (map: L.Map) => {
      apply_layer('OpenTopoMap', map)
    }
  },
  {
    name: 'OpenMapSurfer.Roads',
    apply: (map: L.Map) => {
      apply_layer('OpenMapSurfer.Roads', map)
    }
  },
  {
    name: 'Stamen.TonerBackground',
    apply: (map: L.Map) => {
      apply_layer('Stamen.TonerBackground', map)
    }
  },
  {
    name: 'Stamen.Watercolor',
    apply: (map: L.Map) => {
      apply_layer('Stamen.Watercolor', map)
    }
  },
  {
    name: 'Stamen.Terrain',
    apply: (map: L.Map) => {
      apply_layer('Stamen.Terrain', map)
    }
  },
  {
    name: 'Esri.WorldStreetMap',
    apply: (map: L.Map) => {
      apply_layer('Esri.WorldStreetMap', map)
    }
  },
  {
    name: 'Esri.WorldTopoMap',
    apply: (map: L.Map) => {
      apply_layer('Esri.WorldTopoMap', map)
    }
  },
  {
    name: 'MtbMap',
    apply: (map: L.Map) => {
      apply_layer('MtbMap', map)
    }
  },
  {
    name: 'CartoDB.Positron',
    apply: (map: L.Map) => {
      apply_layer('CartoDB.Positron', map)
    }
  },
  {
    name: 'Wikimedia',
    apply: (map: L.Map) => {
      apply_layer('Wikimedia', map)
    }
  }
])

export let are_cord_same = (c1: L.LatLngLiteral, c2: L.LatLngLiteral): boolean => {
  return c1.lat == c2.lat && c1.lng == c2.lng
}

export let sample_MapStyling: MapStyling = {
  root: 'block block--map',
  root__inner: 'block__inner container--xl grid--block',
  root__search: 'block__search search',
  root__search__label: 'search__label',
  root__search__button: 'search__button',
  root__search__input: 'search__select',
  root__switch: 'switch switch--',
  root__switch__item: 'switch__item',
  root__list: 'block__list',
  root__list__header: 'block__list',
  root__list__title: 'list__title',
  root__list__content: 'list',
  root__map: 'block__map',
  root__map__actions: 'block__switch',
  root__list__content__add_more_items: 'list__button button button--primary',
  cluster_styling: (data: CategoriesList | SimpleList) =>
    function(cluster) {
      var childCount: any = cluster.getChildCount()
      let children = cluster.getAllChildMarkers()
      let is_child_selected = children.find(
        c => (c.options as any).state && (c.options as any).state != 'none'
      )

      if (is_child_selected != undefined) {
        childCount = '!'
      }
      var c = ' marker-cluster-'
      if (childCount < 5) {
        c += 'small'
      } else if (childCount < 19) {
        c += 'medium'
      } else {
        c += 'large'
      }
      children.forEach(c => {
        c.removeEventListener('onpopupclose')
        c.removeEventListener('onmouseover')
        c.removeEventListener('onmouseout')
        c.removeEventListener('onclick')
      })

      return new L.DivIcon({
        html: '<div><span>' + childCount + '</span></div>',
        className: 'marker-cluster' + c,
        iconSize: new L.Point(40, 40)
      })
    }
}

export let setQueryStringParameter = (name: string, value: string) => {
  // let history = useHistory();
  const params = new URLSearchParams(location.search)
  params.set(name, value)
  // history.push(decodeURIComponent(`${location.pathname}?${params}`));
  window.history.replaceState({}, '', decodeURIComponent(`${location.pathname}?${params}`))
}

export let update_params = function(
  s: MapsState,
  route_params: { param: string; value: string }[][]
) {
  let route_params1 = route_params.map(items => {
    if (items.find(i => i.param == 'kind' && i.value == 'map')) {
      if (items.find(e => e.param == 'city') == undefined) {
        items = items.concat([{ param: 'city', value: '' }])
      }
      // if(items.find(e => e.param == "zoom") == undefined){
      //   items = items.concat([{param:"zoom", value:""}])
      // }
      return items
        .map(item => {
          let zoom: number = undefined
          if (s.map == undefined) return item
          if (s.map != 'none') {
            zoom = s.map.leafletElement.getZoom()
          }
          if (item.param == 'city') {
            return { ...item, value: s.search_status.value }
          }
          // if(item.param == "zoom" && zoom){
          //   return {...item, value : `${zoom}`}
          // }
          return item
        })
        .filter(i => i.param != '' && i.value != '')
    } else return items
  })
  return route_params1
}

export let params_to_string = (data: { param: string; value: string }[][]): string => {
  let res = data.map(items => items.map(item => `${item.param}$${item.value}`).join('!')).join(';')
  return res
}
